import { HtmlBuilder } from "./HtmlBuilder";
import { TemplateResult } from "./ContentTemplateResult";
import { WebComponent } from "./WebComponent";

let CachedBuilders=new Map<TemplateStringsArray,HtmlBuilder>();
export function html(fixed:TemplateStringsArray,...args:any[]) {
  let bldr=CachedBuilders.get(fixed);
  if(!bldr) {
    bldr=new HtmlBuilder(fixed);
    CachedBuilders.set(fixed,bldr);
  }
  return new TemplateResult(bldr,args);
}

class AppComponent extends WebComponent {
  RenderApp:()=>any;
  render():any {
    return this.RenderApp();
  }
}
customElements.define("katla-app",AppComponent);

export function mount(el:string|Element,render:()=>any):()=>Promise<void> {
  if (typeof el === "string") el = document.querySelector(el);
  let ac=<AppComponent>document.createElement("katla-app");
  ac.RenderApp=render;
  el.appendChild(ac);
  return ()=>ac.$redraw();
}
